import React, { useState, useEffect } from 'react';
import { Input, InputProps } from '@chakra-ui/react';

interface DebouncedInputProps extends Omit<InputProps, 'onChange' | 'value'> {
  value: string;
  onChange: (value: string) => void;
  debounceMs?: number;
}

/**
 * デバウンス付きInput。
 * ユーザーの入力はローカルstateで即座に反映し、
 * 指定ms後にonChangeを呼び出す。
 */
const DebouncedInput: React.FC<DebouncedInputProps> = React.memo(({ value, onChange, debounceMs = 300, ...rest }) => {
  const [localValue, setLocalValue] = useState(value);

  // 外部からvalueが変わった場合（クリアなど）にローカルstateを同期
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  // ローカルstate変更後、debounceMs後にonChangeを呼ぶ
  useEffect(() => {
    if (localValue === value) return; // 外部同期時はスキップ
    const timer = setTimeout(() => {
      onChange(localValue);
    }, debounceMs);
    return () => clearTimeout(timer);
  }, [localValue, debounceMs]);

  return (
    <Input
      {...rest}
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
    />
  );
});

DebouncedInput.displayName = 'DebouncedInput';

export default DebouncedInput;
